<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <div class="d-flex align-items-center gap-2">
          <h5 class="modal-title" i18n>Pricing Settings</h5>
          <app-page-help articleId="265db486a2" videoId="-"></app-page-help>
        </div>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button (click)="onSave()" type="button" class="btn btn-secondary-info">
          <span class="cs-icon cs-icon-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="main-content">
        <form [formGroup]="form" class="d-flex flex-column align-items-stretch gap-4">
          <div class="container-box p-3">
            <div class="row">
              <div class="col-md-8">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="subtitle" i18n>Pricing</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <mat-form-field2
                      class="mat-block"
                      matTooltip="The default daily price for the listing. Must be between 10 and 25,000."
                      matTooltipPosition="above"
                      i18n-matTooltip
                    >
                      <input
                        type="number"
                        formControlName="default_daily_price"
                        matInput
                        placeholder="Base Price:"
                        i18n-placeholder
                        min="1"
                      />
                      <span matSuffix>{{ currency }}</span>
                    </mat-form-field2>
                  </div>
                  <div class="col-sm-6">
                    <app-select-search
                      [inline]="false"
                      placeholder="Listing Currency"
                      i18n-placeholder
                      [ctrl]="form.get('listing_currency')"
                      [items]="currencyOptions"
                      [multiple]="false"
                    >
                    </app-select-search>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <p class="subtitle" i18n>Discounts</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <mat-form-field2
                      class="mat-block"
                      matTooltip="The value will be copied from Long Term Discount fields in Pricing Rules section if number of days is 7"
                      matTooltipPosition="above"
                      i18n-matTooltip
                    >
                      <input
                        type="number"
                        formControlName="weekly_price_factor"
                        matInput
                        placeholder="Weekly Discount (eg. 30)"
                        i18n-placeholder
                        min="0"
                        max="100"
                      />
                      <span matSuffix>%</span>
                    </mat-form-field2>
                  </div>

                  <div class="col-sm-6">
                    <mat-form-field2
                      class="mat-block"
                      matTooltip="The value will be copied from Long Term Discount fields in Pricing Rules section if number of days is 28"
                      matTooltipPosition="above"
                      i18n-matTooltip
                    >
                      <input
                        type="number"
                        formControlName="monthly_price_factor"
                        matInput
                        placeholder="Monthly Discount (eg. 30)"
                        i18n-placeholder
                        min="0"
                        max="100"
                      />
                      <span matSuffix>%</span>
                    </mat-form-field2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 pt-md-5">
                <div
                  *ngIf="
                    promotionStatus === promotionStatuses.AVAILABLE || promotionStatus === promotionStatuses.ONGOING
                  "
                >
                  <div>
                    <app-form-switch
                      [inline]="true"
                      labelPosition="before"
                      [checked]="promotionStatus === promotionStatuses.ONGOING"
                      (valueChange)="onPromotionStatusChange($event)"
                      i18n
                      >Apply Promotion(20% Discount)</app-form-switch
                    >
                    <div class="text-xs text-muted" i18n>
                      Discount will now expire after a listing earns its first 3 reviews, or reaches 10 bookings —
                      whichever comes first.
                    </div>
                    <div class="text-xs text-muted" i18n>
                      Discount will also apply only to eligible stay dates within 180 days of its creation.
                    </div>
                  </div>
                  <div class="alert alert-secondary-warning2 align-items-start mt-3">
                    <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
                    <div class="alert-content text-xs">
                      <div class="text-semi-bold text-dark" i18n>Eligibility Requirements:</div>
                      <div class="text-muted" i18n>• Airbnb Smart Pricing is turned off</div>
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <app-form-switch
                    [inline]="true"
                    labelPosition="before"
                    [checked]="topRatedGuestDiscount?.enabled"
                    [disabled]="topRatedGuestDiscountLoading || !topRatedGuestDiscount"
                    (valueChange)="onTopRatedGuestDiscountChange($event)"
                    i18n
                    >Enable Top-Rated Guests Discount</app-form-switch
                  >
                  <div class="text-xs text-muted" i18n>
                    Airbnb applies a fixed 15% discount to guests rated 4.8 or higher with at least 3 reviews.
                  </div>
                  <ng-container
                    *ngTemplateOutlet="
                      blackoutDatesTmpl;
                      context: { $implicit: topRatedGuestDiscount, loading: topRatedGuestDiscountLoading }
                    "
                  ></ng-container>
                </div>

                <div class="mt-4">
                  <app-form-switch
                    [inline]="true"
                    labelPosition="before"
                    [checked]="mobileOnlyDiscount?.enabled"
                    [disabled]="mobileOnlyDiscountLoading || !mobileOnlyDiscount"
                    (valueChange)="onMobileOnlyDiscountChange($event)"
                    i18n
                    >Enable Mobile-Only Discount</app-form-switch
                  >
                  <div class="text-xs text-muted" i18n>
                    Airbnb applies a fixed 10% discount to guests booking through the Airbnb mobile app.
                  </div>
                  <ng-container
                    *ngTemplateOutlet="
                      blackoutDatesTmpl;
                      context: { $implicit: mobileOnlyDiscount, loading: mobileOnlyDiscountLoading }
                    "
                  ></ng-container>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <p class="subtitle" i18n>Fees</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <mat-form-field2
                  class="mat-block"
                  matTooltip="The default price to apply for the weekend days. Must be between 10 and 25,000."
                  matTooltipPosition="above"
                  i18n-matTooltip
                >
                  <input
                    type="number"
                    formControlName="weekend_price"
                    matInput
                    placeholder="Weekend Price"
                    i18n-placeholder
                    min="0"
                  />
                  <span matSuffix>{{ currency }}</span>
                </mat-form-field2>
              </div>
              <div class="col-sm-4">
                <mat-form-field2
                  class="mat-block"
                  matTooltip="Number of guests permitted without any additional fees."
                  matTooltipPosition="above"
                  i18n-matTooltip
                >
                  <input
                    type="number"
                    formControlName="guests_included"
                    matInput
                    placeholder="Guests Included"
                    i18n-placeholder
                    min="1"
                    max="90"
                    step="1"
                  />
                </mat-form-field2>
              </div>
              <div class="col-sm-4">
                <mat-form-field2
                  class="mat-block"
                  matTooltip="Amount added to nightly price for each guest over included number."
                  matTooltipPosition="above"
                  i18n-matTooltip
                >
                  <input
                    type="number"
                    formControlName="price_per_extra_person"
                    matInput
                    placeholder="Extra Guest Fee"
                    i18n-placeholder
                    min="0"
                  />
                  <span matSuffix>{{ currency }}</span>
                </mat-form-field2>
              </div>
            </div>
          </div>

          <mat-accordion class="d-flex flex-column align-items-stretch gap-4">
            <div class="container-box">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <p class="subtitle" i18n>Standard Fees</p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Cleaning Fee',
                        form: standardFeesForm.get(standardFeeTypes.cleaningFee),
                        amountType: false,
                        tooltip:
                          'The amount added to clean the listing. Maximum cleaning fee is (' +
                          currency +
                          '600 + 25% nightly price).'
                      }"
                    ></ng-template>
                  </div>

                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Security Deposit',
                        form: standardFeesForm.get(standardFeeTypes.securityDeposit),
                        amountType: false,
                        tooltip:
                          'A refundable deposit that you collect from the guest at the property. Airbnb does not charge or hold it.'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Linen Fee',
                        form: standardFeesForm.get(standardFeeTypes.linenFee),
                        amountType: false,
                        tooltip:
                          'The linens fee is added to the cleaning fee for guests when they book, but it will be a separate item in your payout report.'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Resort Fee',
                        form: standardFeesForm.get(standardFeeTypes.resortFee),
                        amountType: true,
                        tooltip:
                          'The resort fee is added to the nightly price for guests when they book, but it will be a separate item in your payout report.'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Management Fee',
                        form: standardFeesForm.get(standardFeeTypes.managementFee),
                        amountType: true,
                        tooltip:
                          'The management fee is added to the nightly price for guests when they book, but it will be a separate item in your payout report.'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Community Fee',
                        form: standardFeesForm.get(standardFeeTypes.communityFee),
                        amountType: true,
                        tooltip:
                          'The community fee is added to the nightly price for guests when they book, but it will be a separate item in your payout report.'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="standardFeeItem"
                      [ngTemplateOutletContext]="{
                        currency: currency,
                        label: 'Pet Fee',
                        form: standardFeesForm.get(standardFeeTypes.petFee),
                        amountType: false,
                        hint:
                          !isPetsFeeAllowed &&
                          'You need to enable Pets fee on Airbnb website before you can edit it here,'
                      }"
                    ></ng-template>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <div class="container-box">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <p class="subtitle" i18n>Pricing Rules</p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="pricingRuleItem"
                      [ngTemplateOutletContext]="{
                        title: 'Early-bird discount',
                        label: 'Discount ends X months before arrival',
                        ruleType: pricingRuleTypes.earlyBird,
                        form: pricingRulesForm.get(pricingRuleTypes.earlyBird),
                        tooltip:
                          'Discount applied to bookings made at least X number of months in advance of the check-in date'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="pricingRuleItem"
                      [ngTemplateOutletContext]="{
                        title: 'Last-minute discount',
                        label: 'Discount starts X days before arrival',
                        ruleType: pricingRuleTypes.lastMinutes,
                        hint: 'Days should be less than 28',
                        form: pricingRulesForm.get(pricingRuleTypes.lastMinutes),
                        tooltip: 'Discount applied to bookings made within X number of days before the check-in date'
                      }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-6">
                    <ng-template
                      [ngTemplateOutlet]="pricingRuleItem"
                      [ngTemplateOutletContext]="{
                        title: 'Long-term discount',
                        label: 'Length of stay',
                        ruleType: pricingRuleTypes.longTerm,
                        form: pricingRulesForm.get(pricingRuleTypes.longTerm),
                        tooltip:
                          'Discount applied to bookings that last over a specified length of stay. This price supersedes weekly/monthly discounts'
                      }"
                    ></ng-template>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <div class="container-box">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <p class="subtitle" i18n>Occupancy Taxes</p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="alert alert-warning">
                  <ul>
                    <li>
                      <ng-container i18n>Local tax collection</ng-container> <br />
                      <ng-container i18n
                        >Taxes apply to your nightly price and fees for bookings, and we include them in your earnings
                        report. Guests are shown tax amounts as part of the booking total.</ng-container
                      >
                    </li>
                    <li>
                      <ng-container i18n>Automatic tax collection</ng-container> <br />
                      <ng-container i18n
                        >Airbnb automatically collects certain taxes from guests for each booking and remits them
                        directly to local tax authorities.</ng-container
                      >
                      (<a href="https://www.airbnb.com/help/article/1036" target="_blank">
                        https://www.airbnb.com/help/article/1036</a
                      >).
                    </li>
                    <li>
                      <ng-container i18n
                        >Review the tax amounts collected by Airbnb for your listing before adding taxes to your
                        listing.</ng-container
                      >
                      (<a href="https://www.airbnb.com/help/topic/1236" target="_blank"
                        >https://www.airbnb.com/help/topic/1236</a
                      >)
                    </li>
                    <li *ngIf="occupancyTaxNotice">
                      {{ occupancyTaxNotice }}
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col-sm-12" *ngFor="let item of occupancyTaxesForm.controls; let index = index">
                    <ng-template
                      [ngTemplateOutlet]="occupancyTaxItem"
                      [ngTemplateOutletContext]="{ form: item, index: index }"
                    ></ng-template>
                  </div>
                  <div class="col-sm-12" *ngFor="let tax of seasonalOccupancyTaxes">
                    <div class="alert alert-info">
                      <strong>{{ seasonalOccupancyTaxLabel(tax) }}</strong> <br />
                      <ng-container i18n
                        >Seasonal taxes are edited on Airbnb. AdvanceCM keeps this tax unchanged when you
                        save.</ng-container
                      >
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <button type="button" class="btn btn-secondary-info" (click)="addTax()">
                    <i class="far fa-plus"></i> <ng-container i18n>Add</ng-container>
                  </button>
                </div>
              </mat-expansion-panel>
            </div>
          </mat-accordion>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Standard Fees -->
<ng-template
  #standardFeeItem
  let-form="form"
  let-label="label"
  let-tooltip="tooltip"
  let-hint="hint"
  let-amountType="amountType"
  let-currency="currency"
>
  <div class="form-block">
    <div class="row">
      <ng-container [formGroup]="form">
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block subscript-static" [matTooltip]="tooltip" matTooltipPosition="above">
            <mat-label>{{ label }}</mat-label>
            <input
              type="number"
              formControlName="amount"
              matInput
              placeholder="Fee per reservation"
              i18n-placeholder
              min="0"
            />
            <span matSuffix>{{ form.get('amount_type').value === 'percent' ? '%' : currency }}</span>
            <mat-error *ngIf="form.get('amount').hasError('min')">
              <ng-container i18n>Value need to be at least 0</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('amount').hasError('max')">
              <ng-container i18n>Value need to be at most 100</ng-container>
            </mat-error>
            <mat-hint *ngIf="hint">
              {{ hint }}
            </mat-hint>
          </mat-form-field2>
        </div>
        <div class="col-sm-6" *ngIf="amountType">
          <mat-form-field2 class="mat-block">
            <mat-select placeholder="Amount type" i18n-placeholder formControlName="amount_type" required>
              <mat-option value="flat" i18n> Flat </mat-option>
              <mat-option value="percent" i18n> Percent </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Pricing Rules -->
<ng-template
  #pricingRuleItem
  let-title="title"
  let-form="form"
  let-ruleType="ruleType"
  let-label="label"
  let-tooltip="tooltip"
  let-hint="hint"
>
  <div class="form-block">
    <div class="mb-3">{{ title }}</div>
    <div class="d-flex flex-column align-items-stretch" [ngClass]="{ 'gap-3': !!hint }">
      <div
        class="d-flex flex-row align-items-start gap-3"
        *ngFor="let item of form.controls; let i = index"
        [formGroup]="item"
      >
        <div class="row flex-fill">
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block" [matTooltip]="tooltip" matTooltipPosition="above">
              <mat-label>{{ label }}</mat-label>
              <input type="number" formControlName="threshold_one" matInput />
              <span matSuffix>
                <ng-container i18n *ngIf="ruleType === pricingRuleTypes.earlyBird">Months</ng-container>
                <ng-container i18n *ngIf="ruleType !== pricingRuleTypes.earlyBird">Days</ng-container>
              </span>
              <mat-error *ngIf="item.get('threshold_one').hasError('min')">
                <ng-container i18n>Value need to be at least</ng-container>&nbsp;
                <strong>{{ item.get('threshold_one').errors.min.min }}</strong>
              </mat-error>
              <mat-error *ngIf="item.get('threshold_one').hasError('max')">
                <ng-container i18n>Value need to be at most</ng-container>&nbsp;
                <strong>{{ item.get('threshold_one').errors.max.max }}</strong>
              </mat-error>
              <mat-error *ngIf="item.get('threshold_one').hasError('multiple')">
                <ng-container i18n>Value need to be multiple of</ng-container>&nbsp;
                <strong>{{ item.get('threshold_one').errors.multiple }}</strong>
                <ng-container i18n>, and 28 is not allowed.</ng-container>
              </mat-error>
              <mat-hint *ngIf="hint">
                {{ hint }}
              </mat-hint>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block" [matTooltip]="tooltip" matTooltipPosition="above">
              <mat-label i18n>Discount</mat-label>
              <input type="number" formControlName="price_change" matInput />
              <span matSuffix>%</span>
              <mat-error *ngIf="item.get('price_change').hasError('min')">
                <ng-container i18n>Value need to be at least 0</ng-container>
              </mat-error>
              <mat-error *ngIf="item.get('price_change').hasError('max')">
                <ng-container i18n>Value need to be at most 100</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
        <button type="button" class="btn btn-light-danger btn-remove" (click)="removePricingRule(ruleType, i)">
          <i class="cs-icon cs-icon-trash"></i>
        </button>
      </div>
    </div>
    <div class="mb-3" [ngClass]="{ 'mt-2': !hint, 'mt-4': !!hint }">
      <button type="button" class="btn btn-secondary-info" (click)="addPricingRule(ruleType)">
        <i class="far fa-plus"></i> <ng-container i18n>Add</ng-container>
      </button>
    </div>
  </div>
</ng-template>

<!-- Occupancy Tax -->
<ng-template #occupancyTaxItem let-form="form" let-index="index">
  <div class="form-block">
    <div class="row item-row" [formGroup]="form">
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <mat-select placeholder="Tax type" i18n-placeholder formControlName="tax_type" required>
            <mat-option [value]="item.id" *ngFor="let item of airbnbOccupancyTaxesTypes"> {{ item.name }} </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-12"></div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <mat-select placeholder="Amount type" formControlName="amount_type" required>
            <mat-option [value]="item.id" *ngFor="let item of airbnbOccupancyTaxAmountTypes">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <input type="number" placeholder="Amount" formControlName="amount" matInput required />
          <mat-error *ngIf="form.get('amount').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('amount').hasError('min')">
            <ng-container i18n>Value need to be at least</ng-container>&nbsp;
            <strong>{{ form.get('amount').errors.min.min }}</strong>
          </mat-error>
          <mat-error *ngIf="form.get('amount').hasError('max')">
            <ng-container i18n>Value need to be at most</ng-container>&nbsp;
            <strong>{{ form.get('amount').errors.max.max }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <mat-select placeholder="Taxable base" formControlName="taxable_base" multiple>
            <mat-option [value]="item.id" *ngFor="let item of airbnbOccupancyTaxBase"> {{ item.name }} </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('taxable_base').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-12"></div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <input type="number" placeholder="Business tax ID" formControlName="business_tax_id" matInput />
          <mat-error *ngIf="form.get('business_tax_id').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-3 mt-3">
        <mat-checkbox i18n style="margin-top: 1.25rem" formControlName="no_business_tax_id_declaration">
          No Business tax ID
        </mat-checkbox>
      </div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <input
            type="number"
            placeholder="Accommodations tax registration ID"
            formControlName="tot_registration_id"
            matInput
            required
          />
          <mat-error *ngIf="form.get('tot_registration_id').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <!-- <div class="col-sm-3 mt-3">
        <mat-checkbox formControlName="no_tot_registration_id_declaration">
          No accommodations tax registration ID
        </mat-checkbox>
      </div> -->
      <div class="col-12"></div>
      <div class="col-sm-3">
        <mat-form-field2 class="mat-block">
          <input
            type="number"
            placeholder="Long term stay exemption"
            formControlName="long_term_stay_exemption"
            matInput
          />
          <span matSuffix i18n>Nights</span>
          <mat-error *ngIf="form.get('long_term_stay_exemption').hasError('min')">
            <ng-container i18n>Value need to be at least 0</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('long_term_stay_exemption').hasError('integer')">
            <ng-container i18n>Value need to be integer</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <button type="button" class="btn btn-light-danger item-delete-icon" (click)="removeTax(index)">
        <i class="cs-icon cs-icon-trash"></i>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #blackoutDatesTmpl let-discount let-loading="loading">
  <div *ngIf="discount?.enabled" class="mt-2">
    <div class="d-flex align-items-center">
      <span class="text-sm text-semi-bold" i18n>Blackout Dates</span>
      <i
        class="far fa-info-circle text-muted ml-1"
        matTooltip="Select dates to exclude specific high-demand dates from the discount without disabling it. You can select up to 30 dates per calendar year."
        matTooltipPosition="above"
        i18n-matTooltip
      ></i>
      <button
        type="button"
        class="btn btn-secondary-info btn-sm ml-auto"
        [disabled]="loading"
        (click)="openBlackoutDates(discount)"
      >
        <i class="far fa-calendar-alt"></i> <ng-container i18n>Manage Dates</ng-container>
      </button>
    </div>
    <div class="text-xs text-muted mt-1">
      <ng-container *ngIf="!discount.blackout_dates?.length" i18n>The discount applies to all dates.</ng-container>
      <ng-container *ngFor="let range of toBlackoutDateRanges | call : discount.blackout_dates; let last = last"
        >{{ range.label }}<ng-container *ngIf="!last">, </ng-container></ng-container
      >
    </div>
    <div class="text-xs text-muted">
      <ng-container i18n>Dates left:</ng-container>
      <ng-container *ngFor="let quota of getBlackoutDatesYearQuotas | call : discount; let last = last">
        <ng-container i18n>{{ quota.year }}: {{ quota.left }} of {{ quota.total }}</ng-container
        ><ng-container *ngIf="!last">,</ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
